<template>
    <el-table border highlight-current-row ref="tableRef" :data="tableData" :height="tableHeight" :key="tableHeight"
        @selection-change="handleSelectionChange" v-bind="tableOptions"
        header-cell-class-name="custom-table-header-cell-class-name">
        <el-table-column type="expand" v-if="expand">
            <template slot-scope="{row}">
                <slot name="expand" :row="row"></slot>
            </template>
        </el-table-column>
        <el-table-column v-if="showColumnIndex" v-bind="columnIndexOptions" type="index"
            :align="getColumnLabelAlign({})">
            <template #default="scope">
                <slot name="index" :index="scope.$index" :data="scope">
                    {{ scope.$index + 1 }}
                </slot>
            </template>
        </el-table-column>
        <el-table-column v-if="showSelection" type="selection" width="55" :selectable="selectable"
            :align="getColumnLabelAlign({})" />
        <el-table-column v-for="item of schemas" :key="item.prop" show-overflow-tooltip v-bind="item"
            :align="getColumnLabelAlign(item)"></el-table-column>
    </el-table>
</template>
<script>
import { getTableHeight } from './config';

export default {
    props: {
        data: Array,
        tableOptions: {
            type: Object,
            default: () => { }
        },
        schemas: {
            type: Array,
            default: () => []
        },
        showColumnIndex: {
            type: Boolean,
            default: false
        },
        columnIndexOptions: {
            type: Object,
            default: () => {
                return {
                    width: "70",
                    label: "序号",
                }
            }
        },
        showSelection: {
            type: Boolean,
            default: false
        },
        selectable: Function,
        height: Number,
        columnLabelAlign: {
            type: String,
            default: 'center'
        },
        expand: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            myData: [],
            tableHeight: 0,
            selection: []
        }
    },
    computed: {
        tableData() {
            return this.data ?? this.myData
        },
    },
    mounted() {
        this.tableHeight = this.height ?? getTableHeight(this.$refs.tableRef.$el)
    },
    methods: {
        doLayout() {
            this.$nextTick(() => {
                this.$refs.tableRef.doLayout()

            })
        },
        clearSelection() {
            this.$refs.tableRef.clearSelection()
        },
        getSelectionRows() {
            return this.selection
        },
        getColumnLabelAlign(column) {
            return column.align ?? this.columnLabelAlign
        },
        handleSelectionChange(s) {
            this.selection = s
        },
        getTableData() {
            return this.myData
        },
        setTableData(data) {
            this.myData = data
        }
    }
}
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/components/easyTable/index.vue